module.exports = __webpack_public_path__ + "static/media/c23.25523ced.png";